import { render, staticRenderFns } from "./MultiCollectionInput.vue?vue&type=template&id=a965256e&"
import script from "./MultiCollectionInput.vue?vue&type=script&lang=js&"
export * from "./MultiCollectionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports